module.exports = __webpack_public_path__ + "static/media/iso_logo_new.27698de2.png";